import scope from "./scope";
import SelectionState from "state/selections/SelectionState";
import { selectDefinitions } from "./selectors";
import { exchange } from "@ls/js-fetch";
import { fetchBetaDecodes } from "@ls/entity-mapping-service";
import SummaryType from "state/selections/Constants/SummaryType";
import { selectBaseGroupingParams } from "state/selections/selector";

export const SET_DEFINITION = `${scope}/SET_DEFINITION`;
export const setDefinition = (idx, definition) => ({
  type: SET_DEFINITION,
  idx,
  definition,
});

export const SET_DEFINITIONS = `${scope}/SET_DEFINITIONS`;
export const setDefinitions = (definitions) => ({
  type: SET_DEFINITIONS,
  definitions,
});

export const REQUEST_BETA_DECODES = `${scope}/REQUEST_BETA_DECODES`;
export const RECEIVE_BETA_DECODES = `${scope}/RECEIVE_BETA_DECODES`;
export const requestBetaDecodes = () => {
  return async (dispatch) => {
    dispatch({ type: REQUEST_BETA_DECODES });
    dispatch({
      type: RECEIVE_BETA_DECODES,
      data: (await fetchBetaDecodes()) || {},
    });
  };
};

export const requestBetaData = () => {
  return async (dispatch, getState) => {
    const state = getState();

    const betaDefinitions = selectDefinitions(SelectionState.COMMITTED)(state);

    const absBetaTypesSet = new Set(),
      absBetaFactorsSet = new Set(),
      relBetaTypesSet = new Set(),
      relBetaFactorsSet = new Set();
    betaDefinitions.forEach(
      ({ betaId, covarianceType, betaValue, summary }) => {
        const betaType = `${betaId}-${covarianceType}`;
        const betaFactor = betaValue.toUpperCase();
        switch (summary) {
          case SummaryType.ABSOLUTE:
            absBetaTypesSet.add(betaType);
            absBetaFactorsSet.add(betaFactor);
            break;
          case SummaryType.RELATIVE:
            relBetaTypesSet.add(betaType);
            relBetaFactorsSet.add(betaFactor);
            break;
          default:
            throw new Error(`Unknown summary ${summary}`);
        }
      }
    );

    if (absBetaTypesSet.size) {
      dispatch(
        makeBetaRequest(
          SummaryType.ABSOLUTE,
          [...absBetaFactorsSet],
          [...absBetaTypesSet]
        )
      );
    }

    if (relBetaTypesSet.size) {
      dispatch(
        makeBetaRequest(
          SummaryType.RELATIVE,
          [...relBetaFactorsSet],
          [...relBetaTypesSet]
        )
      );
    }
  };
};

export const REQUEST_BETA_DATA = `${scope}/REQUEST_BETA_DATA`;
export const RECEIVE_BETA_DATA = `${scope}/RECEIVE_BETA_DATA`;
export const REQUEST_BETA_SBS_DATA = `${scope}/REQUEST_BETA_SBS_DATA`;
export const RECEIVE_BETA_SBS_DATA = `${scope}/RECEIVE_BETA_SBS_DATA`;
const makeBetaRequest = (summary, betaFactors, betaTypes) => {
  return async (dispatch, getState) => {
    dispatch({ type: REQUEST_BETA_DATA, summary });
    const state = getState();
    const [baseParams, sbsParams] = selectBaseGroupingParams(state);
    const url = process.env.REACT_APP_BASE_URL_GROUPING_SERVICE;

    exchange({
      params: {
        ...baseParams,
        results: baseParams.results + ",BETA_ATTRIBUTES",
        beta_factors: betaFactors.join(","),
        beta_types: betaTypes.join(","),
        summary,
      },
      url,
      cancelId: `beta-data-${summary}`,
    }).then((resp) => {
      dispatch({
        type: RECEIVE_BETA_DATA,
        summary,
        data: resp?.data ?? {},
      });
    });
    if (sbsParams) {
      dispatch({ type: REQUEST_BETA_SBS_DATA, summary });
      exchange({
        params: {
          ...sbsParams,
          results: baseParams.results + ",BETA_ATTRIBUTES",
          beta_factors: betaFactors.join(","),
          beta_types: betaTypes.join(","),
          summary,
        },
        url,
        cancelId: `beta-data-sbs-${summary}`,
      }).then((resp) => {
        dispatch({
          type: RECEIVE_BETA_SBS_DATA,
          summary,
          data: resp?.data ?? {},
        });
      });
    }
  };
};
